import React, { useState } from "react";
import { Toaster, toast } from "react-hot-toast";
import { createUserGroup } from "../Services/APIService";

interface CreateGroupCardProps {
  onCreateComplete: () => void;
  onCancel: () => void;
}

interface FormData {
  groupId: number | "";
  groupName: string;
  isActive: boolean;
}

const CreateGroupCard: React.FC<CreateGroupCardProps> = ({
  onCreateComplete,
  onCancel,
}) => {
  const [formData, setFormData] = useState<FormData>({
    groupId: "",
    groupName: "",
    isActive: true,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : name === "groupId"
          ? value === ""
            ? ""
            : parseInt(value)
          : value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!formData.groupName.trim()) {
      setError("Please enter a Group Name");
      return;
    }

    try {
      setIsLoading(true);

      // Get user ID from localStorage
      const userId = localStorage.getItem("UserId");

      if (!userId) {
        throw new Error("User ID not found in localStorage");
      }

      // Prepare request payload
      const payload = {
        groupName: formData.groupName.trim().replace(/\s+/g, " "),
        isActive: true,
        createdBy: parseInt(userId),
      };

      const data = await createUserGroup(payload);

      if (data.isCreated) {
        toast.success("Group Created Successfully!");
        // Reset form after successful submission
        setFormData({ groupId: "", groupName: "", isActive: true });
        // Call the refresh function
        onCreateComplete();
      } else {
        throw new Error("Failed to create group");
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = () => {
    // Reset form data
    setFormData({ groupId: "", groupName: "", isActive: true });
    setError(null);
    // Call the cancel function
    onCancel();
  };

  return (
    <div className="card mb-4">
      
      <div className="card-header carHeaderWithBtn">
        <h5 className="card-title mb-0">Create Group</h5>
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {error && (
            <div className="alert alert-danger text-danger" role="alert">
              {error}
            </div>
          )}
          <div className="row">
            <div className="col-12 col-lg-4 mb-3">
              <label className="form-label">Group Name</label>
              <input
                type="text"
                name="groupName"
                className="form-control form-control-lg"
                placeholder="Enter Group Name"
                value={formData.groupName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-4 col-lg-12">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? "Creating..." : "Submit"}
              </button>
              <button
                type="button"
                className="btn btn-secondary mx-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateGroupCard;
